import { createSlice } from '@reduxjs/toolkit';

const initialState = ["/"];

const history = createSlice({
	name: 'cart',
	initialState,
	reducers: {
    setHistory: (state, action) => {
      if (state[state.length - 1] !== action.payload) {
        state.push(action.payload);
      }
    },
		clearHistory: () => {
			return initialState;
		},
	},
});

// Export actions and reducer
export const { setHistory, clearHistory } = history.actions;
export default history.reducer;
